// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1MUJm","checkBox":"Checkbox_checkBox__2QKJi","label":"Checkbox_label__2CA8X"};